import * as React from "react";
import { TableCell } from "@mui/material";

interface TableCellProps {
  horaEntrada: string;
}

const formatTime = (
  hours: number,
  minutes: number,
  seconds: number
): string => {
  const formattedHours = String(hours).padStart(2, "0");
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(seconds).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

const calculaTempoEspera = (dateStr: string) => {
  const now = new Date();
  const date = new Date(dateStr);
  const diff = now.getTime() - date.getTime();

  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  return formatTime(hours, minutes, seconds);
};

const DetalhadoTableCell: React.FC<TableCellProps> = ({ horaEntrada }) => {
  const [tempoEspera, setTempoEspera] = React.useState<string>("");

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setTempoEspera(calculaTempoEspera(horaEntrada));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [horaEntrada]);

  return <TableCell align="center">{tempoEspera}</TableCell>;
};

export default DetalhadoTableCell;
